'use client';

import { useEffect } from 'react';

import { useReportServerAuthState } from './user-context';

export const AuthStateSyncClient = ({
  wasAuthenticatedOnServer,
}: {
  wasAuthenticatedOnServer: boolean;
}) => {
  const reportServerAuthState = useReportServerAuthState();

  useEffect(() => {
    reportServerAuthState(wasAuthenticatedOnServer);
  }, [reportServerAuthState, wasAuthenticatedOnServer]);

  return null;
};
